export default __webpack_public_path__ + "static/media/noLab.e2fb6b6d.svg";